import { useProximityHover } from "../../hooks/useProximityHover";

interface ProximityHoverManagerProps {
  tolerance?: number;
}

export function ProximityHoverManager({ tolerance = 15 }: ProximityHoverManagerProps) {
  useProximityHover(tolerance);
  return null;
}
